import { Lock } from 'lucide-react';

interface UpgradeBannerProps {
  feature: string;
  requiredPlan: string;
}

export default function UpgradeBanner({ feature, requiredPlan }: UpgradeBannerProps) {
  return (
    <div className="card p-5 border-amber-200 bg-amber-50">
      <div className="flex items-start gap-4">
        <div className="w-10 h-10 rounded-lg bg-amber-100 flex items-center justify-center flex-shrink-0">
          <Lock className="w-5 h-5 text-amber-600" />
        </div>
        <div>
          <h3 className="text-sm font-semibold text-gray-900">
            {feature} — beschikbaar vanaf {requiredPlan}
          </h3>
          <p className="text-sm text-gray-600 mt-1">
            Deze functie is niet inbegrepen in je huidige plan.
            Upgrade naar <strong>{requiredPlan}</strong> om {feature.toLowerCase()} te gebruiken.
          </p>
          <a
            href="mailto:support@occiput.io?subject=Upgrade%20aanvragen"
            className="inline-flex items-center gap-1 mt-3 text-sm font-medium text-amber-700 hover:text-amber-800"
          >
            Upgrade aanvragen
          </a>
        </div>
      </div>
    </div>
  );
}
